// import { useParams } from "react-router-dom";
import connections from "../../utils/connections.json";
import SearchCard from "../../components/SearchCard";
import Categories from "../../components/Categories";
import { useParams } from "react-router";
import searchCategories from "../../utils/searchCategories.json";
import SearchImages from "../../components/SearchImages";
import { useSelector } from "react-redux";
import thumbnails from "../../utils/thumbnails.json";
import communities from "../../utils/communities.json";
import products from "../../utils/products.json";
import ContentCard from "../../components/ContentCard";
import CommunitiesCard from "../../components/CommunitiesCard";
import ProductCard from "../../components/ProductCard";
import "./Search.css";

const Search = () => {
  let { search } = useParams();
  const { searchCategories: getSearchCategories } = useSelector(
    (state) => state.categories
  );

  const searchVideoCategories = getSearchCategories.find(
    (e) => e.category === "Videos"
  );
  const searchCommunitiesCategories = getSearchCategories.find(
    (e) => e.category === "Communities"
  );

  const searchImagesCategories = getSearchCategories.find(
    (e) => e.category === "Images"
  );

  const searchProductsCategories = getSearchCategories.find(
    (e) => e.category === "Products"
  );

  let filtreConnection = [];

  const otherFiltre =
    searchProductsCategories ||
    searchImagesCategories ||
    searchCommunitiesCategories ||
    searchVideoCategories;

  /*eslint-disable */
  getSearchCategories.find((e) => {
    let name;
    if (
      e.category === "Teachers" ||
      e.category === "Geniuses" ||
      e.category === "Businesses"
    ) {
      if (e.category === "Geniuses") name = "Genius";
      if (e.category === "Teachers") name = "Teacher";
      if (e.category === "Businesses") name = "Business";
      filtreConnection.push(name);
    }
  });

  const connectionsFilter = connections.filter((item) =>
    filtreConnection.includes(item.identity.job)
  );

  return (
    <div>
      <Categories getCategories={searchCategories} center type="search" tabImage={window.location.pathname.split("/")[1] === "images"} />
      {searchVideoCategories && (
        <div className="search__container">
          <h1>Videos</h1>
          <div className="search__videosCategory">
            {thumbnails.map((thumb) => (
              <ContentCard
                title={thumb.title}
                key={thumb.id}
                id={thumb.id}
                img={thumb.img}
                premium={thumb.premium}
                channelName={thumb.channel.name}
                imgChannel={thumb.channel.img}
              />
            ))}
          </div>
        </div>
      )}
      {searchCommunitiesCategories && (
        <div className="search__container">
          <h1>Communities</h1>
          <div className="search__communitiesCategory">
            {communities.map((content) => (
              <CommunitiesCard content={content} key={content.id} />
            ))}
          </div>
        </div>
      )}
      {connectionsFilter.length ? (
        <div className="search__container">
          {connectionsFilter.map((connection) => (
            <SearchCard connection={connection} key={connection.id} />
          ))}
        </div>
      ) : (
        !otherFiltre && (
          <div className="search__container">
            {connections.map((connection) => (
              <SearchCard connection={connection} key={connection.id} />
            ))}
          </div>
        )
      )}
      {(searchImagesCategories ||
        window.location.pathname.split("/")[1] === "images") && (
        <div className="search__container">
          <h1>Images</h1>
          <SearchImages searchName={search} />
        </div>
      )}
      {searchProductsCategories && (
        <div className="search__container">
          <h1>Products</h1>
          <div className="search__shopCategory">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                title={product.title}
                img={product.img}
                id={product.id}
                colors={product.colors}
                sizes={product.sizes}
                price={product.price}
                tags={product.tags}
                rating={product.rating}
                description={product.description}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Search;
